export type PolygonPointArray = string[] | number[][];

export type ColoredPolygon = { points: PolygonPointArray; color: string };

export type PolygonEntry = PolygonPointArray | ColoredPolygon;

export interface AiDetectionResult {
  class: string;
  Condition?: string;
  Severity?: string;
  showForGender?: string;
  scalp_masks?: string;
  BoundingBoxes?: string[];
  PolygonPointsSequences?: PolygonEntry[];
  ellipse_points?: { left?: string[]; right?: string[] };
  hairline_points?: string[];
  ideal_hairline?: string[];
  ProblemName?: string;
  severity?: string;
}

export const SCALP_SEGMENT_CLASS = 'scalp-segment';

export const ScalpSeverity = {
  Normal: 'Normal',
  Mild: 'Mild',
  Moderate: 'Moderate',
  Severe: 'Severe',
  Unknown: 'Unknown',
} as const;

export type ScalpSeverityValue = typeof ScalpSeverity[keyof typeof ScalpSeverity];

export enum ScalpCardState {
  Detected = 'DETECTED',
  Normal = 'NORMAL',
  NoDetection = 'NO_DETECTION',
  None = 'NONE',
}

export interface ScalpCardCopy {
  title: string;
  description?: string;
  reasonsHeading?: string;
  reasons?: string[];
}

export type ScalpCopyGender = 'Male' | 'Female';

export interface ScalpNoDetectionCopy {
  title: string;
  reasonsHeading: string;
  reasons: string[];
}

export interface ScalpSeverityLanguageCopy {
  titles: Record<ScalpSeverityValue, string>;
  descriptions: Record<ScalpCopyGender, Record<ScalpSeverityValue, string>>;
  noDetection: ScalpNoDetectionCopy;
}
